import N8nHeading from './Heading.vue';

export default N8nHeading;
